// Password reset - calls Rails backend directly (no Firebase)

document.addEventListener('turbo:load', () => {
  const forgotForm = document.getElementById('forgot-password-form');
  const errorDiv = document.getElementById('error-message');
  const successDiv = document.getElementById('success-message');
  const noPasswordModal = document.getElementById('no-password-modal');
  
  // Check if the path starts with /en (our only non-default locale)
  const pathSegment = window.location.pathname.split('/')[1];
  const localePrefix = (pathSegment === 'en') ? '/en' : '';

  if (forgotForm) {
    forgotForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      showLoading(true);
      hideMessages();
      
      const email = document.getElementById('email').value;

      try {
        // Check our backend first to see if user exists and has password
        const checkResponse = await fetch(`${localePrefix}/forgot-password/check`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ email: email })
        });

        const checkData = await checkResponse.json();

        if (!checkData.user_exists) {
          showLoading(false);
          showError(window.I18n?.['auth.forgot_password.errors.user_not_found'] || 'No account found with this email');
          return;
        }

        if (!checkData.has_password) {
          // User exists but has no password (Google-only account)
          showLoading(false);
          showNoPasswordModal(email);
          return;
        }

        // User exists and has password - send reset email via Rails
        const resetResponse = await fetch(`${localePrefix}/forgot-password/send-reset`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ email: email })
        });

        const resetData = await resetResponse.json();

        showLoading(false);
        if (resetData.success) {
          showSuccess(window.I18n?.['auth.forgot_password.success_message'] || 'Password reset email sent! Check your inbox.');
          forgotForm.reset();
        } else {
          showError(resetData.error || 'Failed to send reset email');
        }

      } catch (error) {
        console.error('Forgot password error:', error);
        showLoading(false);
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Connection error. Please try again.');
      }
    });
  }

  // Handle no password modal buttons
  const sendLinkBtn = document.getElementById('no-password-send-link-btn');
  const useGoogleBtn = document.getElementById('no-password-google-btn');
  const closeModalBtn = document.getElementById('no-password-close-btn');

  if (sendLinkBtn) {
    sendLinkBtn.addEventListener('click', async () => {
      const email = document.getElementById('no-password-email').textContent;
      
      try {
        // Send password setup link via Rails for Google-only users
        const response = await fetch(`${localePrefix}/forgot-password/send-setup-link`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({ email: email })
        });

        const data = await response.json();
        
        hideNoPasswordModal();
        if (data.success) {
          showSuccess(
            window.I18n?.['auth.forgot_password.setup_link_sent'] || 
            "We've sent you a password setup email. Check your inbox!"
          );
        } else {
          showError(data.error || 'Failed to send setup link');
        }

      } catch (error) {
        console.error('Send setup link error:', error);
        hideNoPasswordModal();
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Connection error. Please try again.');
      }
    });
  }

  if (useGoogleBtn) {
    useGoogleBtn.addEventListener('click', () => {
      window.location.href = `${localePrefix}/login`;
    });
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', () => {
      hideNoPasswordModal();
    });
  }

  function showNoPasswordModal(email) {
    document.getElementById('no-password-email').textContent = email;
    noPasswordModal?.classList.remove('hidden');
  }

  function hideNoPasswordModal() {
    noPasswordModal?.classList.add('hidden');
  }

  function showError(message) {
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.classList.remove('hidden');
    }
  }

  function showSuccess(message) {
    if (successDiv) {
      successDiv.textContent = message;
      successDiv.classList.remove('hidden');
    }
  }

  function hideMessages() {
    errorDiv?.classList.add('hidden');
    successDiv?.classList.add('hidden');
  }

  function showLoading(loading) {
    const btnText = document.getElementById('reset-btn-text');
    const btnLoading = document.getElementById('reset-btn-loading');
    
    if (loading) {
      btnText?.classList.add('hidden');
      btnLoading?.classList.remove('hidden');
    } else {
      btnText?.classList.remove('hidden');
      btnLoading?.classList.add('hidden');
    }
  }
});
